<script setup lang="ts">
import SmallModel from "@/components/Interface/Modal/ModelSizes/SmallModel.vue";
import {useGameStore} from "@/stores/gameStore.ts";
import {usePlayerRelationStore} from "@/stores/playerRelations.ts";
import PlayerName from "@/components/Objects/PlayerName.vue";
import {useShipActionStore} from "@/stores/shipActionStore.ts";
import { onMounted, ref } from 'vue'
import { useMapCoordinateStore } from '@/stores/mapCoordinateStore.ts'
import * as Sentry from '@sentry/vue'
import { logger } from '@/models/logger';

// Get the planet data
const gameStore = useGameStore()
const playerRelation = usePlayerRelationStore()
const shipActionPath = useShipActionStore()
const mapCoordinateStore = useMapCoordinateStore()

//List of players that are there and are enemies
const players = ref(new Map<number, number>());

const follow = (targetPlayer: number) => {
  // Add Sentry breadcrumb to track when user clicks in modal
  Sentry.addBreadcrumb({
    category: 'ship-action',
    message: 'User clicked follow in modal',
    level: 'info',
    data: {
      targetPlayer: targetPlayer,
      modalDataXPos: gameStore.modalData?.xPos,
      modalDataYPos: gameStore.modalData?.yPos,
      modalDataType: typeof gameStore.modalData,
      modalDataIsArray: Array.isArray(gameStore.modalData),
      modalDataKeys: gameStore.modalData ? Object.keys(gameStore.modalData) : [],
      modalDataXPosType: typeof gameStore.modalData?.xPos,
      modalDataYPosType: typeof gameStore.modalData?.yPos,
      pendingAction: shipActionPath.pendingAction
    }
  })

  /**
   * Queue the follow action
   */
  shipActionPath.queuePendingAction(
      gameStore.modalData.xPos,
      gameStore.modalData.yPos,
      targetPlayer,
      0
  );
  // Close the modal
  gameStore.modalType = '';
}

const loadMapCoordinate = async () => {
  try {

    const data = mapCoordinateStore.getByCoordinates(gameStore.modalData.xPos, gameStore.modalData.yPos);

    //check if the ships are from an enemy
    for (const playerId of Object.keys(data.mapCoordinate.ships)) {
      const numericPlayerId = Number(playerId);
      if (!players.value.has(numericPlayerId) && numericPlayerId > 0) {
        players.value.set(
          numericPlayerId,
          numericPlayerId
        );
      }
    }

  } catch (error) {
    logger.error(error);
  }
};

onMounted(() => {
  loadMapCoordinate()
});


</script>

<template>
  <SmallModel title="Which player do you wish to follow?">
    <div class="p-1 grid grid-cols-3 gap-2">
      <div v-for="playerId in players.values()" :key="playerId">
        <div
          @click="follow(playerId)"
          class="p-2 m-2 cursor-pointer rounded bg-slate-800">
          <div class="overflow-hidden">
            <img
              v-if="playerId != gameStore.player?.id"
              :src="playerRelation.getProfileImageByPlayerId(playerId)"
              class="w-full h-full object-cover rounded"
              alt=""
            />
            <img
              v-else
              :src="gameStore.player?.profileImage"
              class="w-full h-full object-cover rounded"
              alt=""
            />
          </div>
          <div class="text-center pt-2">
            <div>
              <PlayerName :player-id="playerId" :disable-modal="true"></PlayerName>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="players.size === 0">
      <div class="text-subtext p-5 text-center">Nobody to follow here</div>
    </div>
    <div v-else>
      <div class="text-subtext p-5 text-center">Your ship(s) will target one ship of the selected player to follow.</div>
    </div>
  </SmallModel>
</template>


<style scoped lang="scss">

</style>